import { render, staticRenderFns } from "./FTransactionList.vue?vue&type=template&id=32fcfc2c&"
import script from "./FTransactionList.vue?vue&type=script&lang=js&"
export * from "./FTransactionList.vue?vue&type=script&lang=js&"
import style0 from "./FTransactionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports